export default __webpack_public_path__ + "static/media/menuInfo.b34e65b6.svg";